import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style.css'

interface NextItemProps {
  to?: string; // 이동할 URL을 나타내는 props
  thumbnail?: string;
  nextProjectTitle?: string;
}

const NextItem: React.FC<NextItemProps> = ({ to, thumbnail, nextProjectTitle }) => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [scrolledToBottom, setScrolledToBottom] = useState<boolean>(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      setScrolledToBottom(scrollTop + clientHeight >= scrollHeight - 1);

      if (scrollTop > 200) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const Click = () => {
    if (to) {
      navigate(to); // 특정 URL로 이동
    }
  };


  return (
    <>
      {/* 데스크톱 버전 */}
      <button className={`next-item desktop-only ${isVisible ? 'show' : ''} ${scrolledToBottom ? 'scrolled-to-bottom' : ''} ${thumbnail ? '' : 'next-item--no-thumbnail'}`}
        onClick={Click}>
          {thumbnail && (
            <div className="next-item-thumbnail">
              <img src={thumbnail} />
            </div>
          )}
          <div className="next-sign">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M7 17L17 7M9 7h8v8" />
            </svg>
          </div>
          <div className='next-item-text'>
            <div className='next-text'>Next</div>
            <div className='next-project-title'>{nextProjectTitle}</div>
          </div>
      </button>

      {/* 모바일 버전 - BackButton과 동일한 스타일 */}
      <button className={`floatingButton next-button-mobile mobile-only ${isVisible ? 'show' : ''} ${scrolledToBottom ? 'scrolled-to-bottom' : ''}`} onClick={Click}>
        <span className="next-button-text">
          {scrolledToBottom ? nextProjectTitle : 'Next'}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M5 12h14m-7-7l7 7-7 7" />
        </svg>
      </button>
    </>
  );
};

export default NextItem;
